import theme from '@totallymoney/ui/theme'

import { StyledIcon, StyledNextLink } from './NextLinkWithChevron.styled'

const NextLinkWithChevron = ({
    href,
    text,
}: {
    href: string
    text: string
}) => (
    <StyledNextLink href={href}>
        {text}

        <StyledIcon icon="chevronRight" color={theme.indigo60} size={14} />
    </StyledNextLink>
)

export default NextLinkWithChevron
